import {satGlobals} from "../../../../../sat/helper/sat-globals";
import axios from 'axios';
import {useResultPageStore} from "../stores/ResultPageStore";
import {JOB_STATE_UPLOADING, JOB_STATE_UPLOADING_COMPLETE} from "../const/job.const";
import OutputSelectionManager from "../manager/OutputSelectionManager";
import Analytics from "./Analytics";

let selectedOutputs = [];
let selectedJob = null;

function _getToken(tokenClient) {
    let that = this;
    tokenClient.callback = async (response) => {
        if (response.error !== undefined) {
            throw (response);
        }
        _handleAuthResult(response.access_token);
    };
    tokenClient.requestAccessToken({prompt: 'consent'});
}

function _handleAuthResult(authResult) {
    _saveToDrive(authResult);
}

async function _saveToDrive(accessToken) {
    let store = useResultPageStore();
    /*
    var data = {
        url: rsUrl,
        data: {
            oauthToken: accessToken,
        },
    };

     */
    let payload = [];

    selectedOutputs.forEach((output) => {
        payload.push( {
            id: output.id,
            url: output.uri.replace('download-file', 'gdrive-uploader'),
            data: {
                oauthToken: accessToken,
            }
        })
    });
    for (const uploadItem of payload) {
        let output =  store.getOutputById(selectedJob.id, uploadItem.id);
        output.status = 'uploading-init';
    }

    for (const uploadItem of payload) {
        let output =  store.getOutputById(selectedJob.id, uploadItem.id);
        output.status = 'uploading';
        
        let form = new FormData();
        form.append('oauthToken', uploadItem.data.oauthToken)
        
        await axios.post( uploadItem.url, form, { withCredentials: true, headers: { 'Content-Type': 'multipart/form-data' } });
        
        output.status = 'uploading-done';
    }

    Analytics.send('result_gdrive', 'upload_done');
    selectedJob.state = JOB_STATE_UPLOADING_COMPLETE;
}

class Gdrive {

    listener = false;

    constructor() {
    }

    async uploadJob(job) {
        Analytics.send('result_gdrive', 'upload_job', job);

        selectedOutputs = job.apiJob.output;
        selectedJob = job;
        
        selectedJob.state = JOB_STATE_UPLOADING;
        selectedJob.uploadTo = 'gdrive';

        this._startGoogleFlow();
    }

    async uploadSelectedOutputs(job) {
        Analytics.send('result_gdrive', 'upload_selected_outputs', job);

        selectedOutputs = OutputSelectionManager.getSelectedOutputs(job);
        selectedJob = job;

        selectedJob.state = JOB_STATE_UPLOADING;
        selectedJob.uploadTo = 'gdrive';
        
        this._startGoogleFlow();
    }

    async _startGoogleFlow() {
        if (sessionStorage.getItem('PLAYWRIGHT') === 'true') {
            return;
        }

        let that = this;
        $.when(
            $.cachedScript('https://apis.google.com/js/api.js'),
            $.cachedScript('https://accounts.google.com/gsi/client')
        ).done(function () {
            window.gapi.load('client', that._initClient);
        });
    }

    async _initClient() {
        gapi.client.init({
            apiKey: window.sat.gdriveConfig.developerKey,
            discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'],
        });

        let tokenClient = google.accounts.oauth2.initTokenClient({
            client_id: window.sat.gdriveConfig.clientId,
            scope: 'https://www.googleapis.com/auth/drive.file',
        });

        _getToken(tokenClient)
    }

    _getToken(tokenClient) {
        let that = this;
        tokenClient.callback = async (response) => {
            if (response.error !== undefined) {
                throw (response);
            }
            that._handleAuthResult(response.access_token);
        };
        tokenClient.requestAccessToken({prompt: 'consent'});
        /*
                if (_oauthToken === null) {
                    // Prompt the user to select a Google Account and ask for consent to share their data
                    // when establishing a new session.
                    tokenClient.requestAccessToken({prompt: 'consent'});
                } else {
                    // Skip display of account chooser and consent dialog for an existing session.
                    tokenClient.requestAccessToken({prompt: ''});
                }
                */
    }

    _handleAuthResult(authResult) {
        var accessToken = null;

        try {
            accessToken = authResult.access_token;
        } catch (e) {
        }

        this.saveToDrive(accessToken);
    }

    saveToDrive(accessToken) {
        var data = {
            url: rsUrl,
            data: {
                oauthToken: accessToken,
            },
        };
    }
}

export default new Gdrive()